<template>
  <PageViewContainer>
    <CardContainer>
      <template v-slot:title>
        {{ text.pages.userHistory.title }}: {{ $store.state.user.username }}
      </template>
      <template v-slot:content v-if="orders">
        <UserHistoryTable :user-history="orders"/>
      </template>
    </CardContainer>
  </PageViewContainer>
</template>

<script>
import Axios from '@/core/Axios';
import CardContainer from '@/components/Partials/CardContainer.vue';
import { translations } from '@/lang/translations';
import UserHistoryTable from '@/components/Pages/UserHistoryTable.vue';
import PageViewContainer from '@/components/Partials/PageViewContainer.vue';

export default {
  name: 'UserHistoryView',
  components: { PageViewContainer, UserHistoryTable, CardContainer },
  data() {
    return {
      axios: new Axios(),
      orders: null,
    };
  },
  mounted() {
    this.getHistory();
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    user() {
      this.redirectIfNotLogged();
    },
  },
  methods: {
    redirectIfNotLogged() {
      if (!this.$store.state.user) {
        this.$router.push('/');
      }
    },
    getHistory() {
      this.redirectIfNotLogged();

      this.axios.makeCall('POST', 'norbit/order/history', {
        uid: this.$store.state.user.uid,
      })
        .then((response) => {
          this.orders = response;
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });
    },
  },
};
</script>

<style scoped>
</style>
